import { $, _, hljs, showdown } from '../lib';
import { j2h } from './component-j2h';
export const markdownToHTMLProxy = (md, heading_lvl = 2) => {
    const this_converter = new showdown.Converter({
        headerLevelStart: heading_lvl,
        ghMentionsLink: '#mention',
    });
    this_converter.setFlavor('github');
    this_converter.setOption('parseImgDimensions', true);
    this_converter.setOption('smoothLivePreview', true);
    md = md.replace(/\s-+>\s/g, ' → ');
    md = md.replace(/\s<-+\s/g, ' ← ');
    md = md.replace(/<(.*?)>/g, '&lt;$1&gt;');
    let html = this_converter.makeHtml(md);
    const re = /<a href="<a href=".*?">.*?">.*?>(.*?)<\/a><\/a>/g;
    html = html.replace(re, '<code>$1</code>');
    const $elem = $('<div/>');
    $elem.html(html);
    $elem.find('code.wikitable').each((_i, el) => {
        const $block = $(el);
        const $parent = $block.parent();
        const $el = $(convertWikiTable($block.html()));
        $el.addClass('wikitable');
        $parent.replaceWith($el);
    });
    $elem.find('table.wikitable td, table.wikitable th').each((_i, el) => {
        md = el.innerText;
        if (md.length > 0 && md[0]?.trim() === '>') {
            let lines = md.trim().substring(1).split('\n').slice(1);
            while (lines.length > 0 &&
                _.every(_.map(lines, (x) => x[0] === ' ' || !x))) {
                lines = lines.map((x) => x.substring(1));
            }
            md = lines.join('\n');
        }
        el.innerHTML = markdownToHTMLProxy(md);
        if (el.children.length === 1 && el.children[0]?.tagName.toUpperCase() === 'P') {
            el.innerHTML = el.children[0]?.innerHTML ?? '';
        }
    });
    $elem.find('code').each((_i, block) => {
        const $block = $(block);
        const $parent = $block.parent();
        if ($parent.is('p') || $parent.is('li') || $parent.is('td')) {
            $block.css({ display: 'inline' }).addClass('hljs');
        }
        else {
            hljs.highlightElement(block);
        }
        if ($block.hasClass('text')) {
            $block.addClass('hljs');
        }
        html = $block.html();
        html = html.replace(/&amp;gt;/g, '>');
        html = html.replace(/&amp;lt;/g, '<');
        $block.html(html);
    });
    const keys = {
        '[grey]': 'grey',
        '[red]': 'red',
        '[yellow]': 'yellow',
        '[green]': 'green',
    };
    $elem.find('blockquote').each((_i, bq) => {
        let src;
        _.forEach(keys, (v, k) => {
            if (bq.innerText.trim().startsWith(k)) {
                bq.classList.add('box');
                bq.classList.add(v);
                let node = bq;
                while (node?.nodeType !== 3) {
                    node = getFirstNonEmptyChild(node);
                }
                node.data = node.data.substring(k.length);
            }
        });
        if (bq.innerText.trim().startsWith('[audio]')) {
            bq.classList.add('media-container');
            src = bq.innerText.trim().substring(7).trim();
            bq.innerText = '';
            bq.appendChild(j2h({
                tag: 'audio',
                attr: { controls: '' },
                children: [
                    {
                        tag: 'source',
                        attr: {
                            src,
                            type: 'audio/wav',
                        },
                    },
                    {
                        tag: 'span',
                        text: 'Audio clip - browser not supported',
                    },
                ],
            }));
        }
        if (bq.innerText.trim().startsWith('[youtube]')) {
            bq.classList.add('media-container');
            src = bq.innerText.trim().substring(9).trim();
            bq.innerText = '';
            bq.appendChild(j2h({
                tag: 'iframe',
                attr: {
                    width: 560,
                    height: 315,
                    src: `https://www.youtube-nocookie.com/embed/${src}`,
                    frameborder: '0',
                    allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
                    allowfullscreen: '',
                },
            }));
        }
        if (bq.innerText.trim().startsWith('[video]')) {
            bq.classList.add('media-container');
            src = bq.innerText.trim().substring(7).trim();
            bq.innerText = '';
            bq.appendChild(j2h({
                tag: 'video',
                attr: {
                    controls: '',
                    width: 560,
                },
                children: [
                    {
                        tag: 'source',
                        attr: {
                            src,
                            type: 'video/mp4',
                        },
                    },
                    {
                        tag: 'span',
                        text: 'Video clip - browser not supported',
                    },
                ],
            }));
        }
        if (bq.innerText.trim().startsWith('[gif]')) {
            bq.classList.add('media-container');
            src = bq.innerText.trim().substring(5).trim();
            bq.innerText = '';
            bq.appendChild(j2h({
                tag: 'video',
                attr: {
                    loop: '',
                    autoplay: '',
                    playsinline: '',
                    disablepictureinpicture: '',
                    width: 560,
                },
                children: [
                    {
                        tag: 'source',
                        attr: {
                            src,
                            type: 'video/mp4',
                        },
                    },
                    {
                        tag: 'span',
                        text: 'Video clip - browser not supported',
                    },
                ],
            }));
        }
        if (bq.innerText.trim().startsWith('[tmsnote]')) {
            bq.classList.add('tms-note-embed-link');
            bq.classList.add('box');
            bq.classList.add('grey');
            bq.setAttribute('data-key', bq.innerText.trim().substring(9).trim());
            bq.innerText = 'Loading TMS Note...';
        }
    });
    const pattern = RegExp(/^\d*?x\d*$/);
    $elem.find('img').each((_i, el) => {
        const alt = el.alt ?? '';
        if (alt.match(pattern)) {
            const [w, h] = alt.split('x');
            el.style.maxWidth = `min(100%, ${w}px)`;
            el.style.maxHeight = `${h}px`;
            el.alt = '';
        }
    });
    $elem.find('a').each((_i, el) => {
        const href = el.getAttribute('href');
        if (href && /^javascript:/i.test(href)) {
            el.removeAttribute('href');
            el.style.cursor = 'default';
        }
        else {
            el.setAttribute('target', '_blank');
        }
    });
    $elem.find('a[href="#mention"]').each((_i, el) => {
        el.target = '';
        el.classList.add('mention');
        el.addEventListener('click', () => false);
        const text = el.innerText;
        el.innerText = '';
        el.appendChild(j2h({
            tag: 'span',
            class: 'at',
            text: '@',
        }));
        el.appendChild(j2h({
            tag: 'span',
            class: 'name',
            text: text.substring(1),
        }));
    });
    $elem.find('input[type="checkbox"]:checked').parent().addClass('lb_checked');
    return $elem.html();
};
export const markdownToHTML = ($elem, text, heading_level) => {
    if ($elem === undefined || $elem === null) {
        return text;
    }
    const html = markdownToHTMLProxy(text, heading_level);
    $elem.addClass('to_document');
    $elem.html(html);
};
const getFirstNonEmptyChild = (el) => {
    let found = null;
    _.forEach(el.childNodes, n => {
        if (found) {
            return;
        }
        if (n.textContent && n.textContent.trim() !== '') {
            found = n;
        }
    });
    return found;
};
export const getClientSuitableMarkdown = (md, references, heading_level) => {
    if (references == null) {
        references = {};
    }
    if (md == null) {
        md = '';
    }
    const pattern = /\bKB#([0-9]+)\b/g;
    md.match(pattern)?.forEach((x) => {
        const ID = +x.substring(3);
        const title = references[ID] ?? 'Unknown Article';
        md = md.replace(x, `[KB: ${title}](/kb/${ID}/)`);
    });
    const p1 = new RegExp('\\[TMSS(#[0-9a-f]+)\\]', 'gi');
    const p2 = new RegExp('\\bTMS+(#[0-9a-f]+)', 'gi');
    md = md.replace(p1, '');
    md = md.replace(p2, '`$1`');
    return markdownToHTMLProxy(md, heading_level);
};
const convertWikiTable = (value) => {
    let attrs = '';
    let headers = '';
    let rows = '';
    const renderTables = (wiki) => {
        wiki.replace(findTable, parseTable);
        let HTML = `<table ${attrs ?? ''}>`;
        if (headers) {
            HTML += `<thead>${headers}</thead>`;
        }
        if (rows) {
            HTML += `<tbody>${rows}</tbody>`;
        }
        HTML += '</table>';
        attrs = headers = rows = '';
        return HTML;
    };
    const findTable = new RegExp(/\{\|\s*(.*?)\s*\|\}/, 'gs');
    const parseTable = (_match, content) => {
        Array.prototype.forEach.call(content.split(newRow), renderRow);
        return '';
    };
    const newRow = new RegExp(/\s*\|-\s*(?:\|\s*)?/, 'gs');
    const renderRow = (content) => {
        if (content.indexOf('=') !== -1) {
            attrs += content;
        }
        else if (content[0] === '!') {
            headers += `<tr>${content.replace(findHeader, renderHeader)}</tr>`;
        }
        else {
            rows += `<tr>${content.replace(findCol, renderCol)}</tr>`;
        }
    };
    const findHeader = new RegExp(/\s*!\s*([^!]+?)(?=\s*!|$)/, 'gs');
    const renderHeader = '<th>$1</th>';
    const findCol = new RegExp(/(?:^\s*|\s*\|\s*)([^\|]+?)(?=\s*\||$)/, 'gs');
    const renderCol = '<td>$1</td>';
    return renderTables(value);
};
//# sourceMappingURL=component-markdown.js.map